import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { supabase } from '../supabase';
import { getSupabaseAuthSessionCoalesced } from '../utils/asyncReliability';
import { PLANS_CONFIG, PRO_MONTHLY_USD } from '../config/plans';

/**
 * Legacy route: redirects signed-in users to in-app billing; others to marketing /plans.
 */
const SelectPlan = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data: { session } } = await getSupabaseAuthSessionCoalesced(supabase);
      if (cancelled) return;
      if (session?.user) {
        navigate('/dashboard/settings?plans=1', { replace: true });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-16">
      <div className="max-w-lg w-full rounded-2xl border border-slate-200 bg-white p-8 shadow-sm text-center">
        <h1 className="text-2xl font-bold text-slate-900">Plans & pricing</h1>
        <p className="mt-2 text-slate-600 text-sm">
          Devello now uses a simple <strong>Free</strong> and <strong>Pro (${PRO_MONTHLY_USD}/mo)</strong> model. Sign in
          to choose a plan and pay securely with Stripe.
        </p>
        <div className="mt-8 space-y-3 text-left text-sm text-slate-600">
          <p>
            <strong className="text-slate-900">{PLANS_CONFIG.free.name}</strong> — {PLANS_CONFIG.free.description}
          </p>
          <p>
            <strong className="text-slate-900">{PLANS_CONFIG.pro.name}</strong> — {PLANS_CONFIG.pro.description}
          </p>
        </div>
        <div className="mt-8 flex flex-col gap-3">
          <Link
            to="/account?signup=1"
            className="inline-flex justify-center rounded-xl bg-primary px-5 py-3 text-sm font-semibold text-white hover:bg-primary-dark"
          >
            Create account
          </Link>
          <Link
            to="/account"
            className="inline-flex justify-center rounded-xl border border-slate-200 bg-white px-5 py-3 text-sm font-semibold text-slate-800 hover:bg-slate-50"
          >
            Sign in
          </Link>
          <Link to="/plans" className="text-sm font-medium text-primary hover:underline">
            View full comparison
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SelectPlan;
